import { styled, Drawer } from '@mui/material';

export const StyledDrawer = styled(Drawer, {
	shouldForwardProp: (prop) => prop !== 'isMobile' && prop !== 'maxWidth',
})(({ isMobile = false, maxWidth = '600px' }) => ({
	'& .MuiDrawer-paper': {
		maxWidth: isMobile ? '100%' : maxWidth,
		minWidth: isMobile ? '100%' : '300px',
		borderRadius: '0',
		maxHeight: 'calc(100vh - 60px)', // account for AppBar height + appBar borderRadius
		marginBottom: isMobile ? '60px' : 0, // if anchor is bottom (tru for mobile), add margin to bottom
	},
}));
export default StyledDrawer;
